module.exports = __webpack_public_path__ + "static/media/joint.f89a8b1b.png";